import { useQuery } from 'react-query';
import { getData } from 'src/Utils/api';
import { sortAssignableUsersByLastName } from 'src/Utils/adminUsersService';
export var useTicketFilters = function (options) {
    var fetchAdmins = (options === null || options === void 0 ? void 0 : options.fetchAdmins) !== false;
    var _a = useQuery('buildings', function () {
        return getData('/buildings').then(function (res) { return res.buildings || []; });
    }).data, buildings = _a === void 0 ? [] : _a;
    var _b = useQuery('admin_users', function () { return getData('/admin_users').then(function (res) { return res.admin_users || []; }); }, { enabled: fetchAdmins }).data, admins = _b === void 0 ? [] : _b;
    var statusOptions = [
        { value: 'pending', label: 'Pendiente' },
        { value: 'open', label: 'Abierto' },
        { value: 'completed', label: 'Completado' },
    ];
    return {
        buildings: buildings,
        admins: sortAssignableUsersByLastName(admins),
        statusOptions: statusOptions,
    };
};
